enum AddOwnershipPages {
    AddOwnershipLandingPage,
    OwnerDeviationsPage,
    NewOwnerDecimalInterest,
    DeviationDecimalInterest,
    NewDeviationInfoForm,
    NewOwnerInfoForm,
    NewOwnerVestingInterestForm,
    DeviationVestingInterestForm,
}

export default AddOwnershipPages;



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/AddOwnershipPages.ts